/** True on handheld field devices: coarse pointer AND narrow viewport. */
export function isCompactDevice(): boolean {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false;
  return window.matchMedia('(pointer: coarse)').matches
    && window.matchMedia('(max-width: 640px)').matches;
}

/**
 * True on any touch-first device, INCLUDING tablets.
 *
 * Deliberately has no width test. isCompactDevice() requires <=640px, which
 * excludes a tablet in portrait (768-834px) — so gating an operator's field
 * worklist on it leaves them with no navigation entry at all.
 *
 * Kept SEPARATE from isCompactDevice() rather than widening it: Scouting's
 * three callers use isCompactDevice() to choose between a desktop and a
 * handheld recorder, and widening it would flip those on every tablet.
 */
export function isFieldDevice(): boolean {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false;
  return window.matchMedia('(pointer: coarse)').matches;
}
